const baseURL = process.env.REACT_APP_BASE_URL;

export const getImg = (id) => {
  if (!id) return null;
  return `https://api.dreasey.com/api/Storage/GetImageById?id=${id}`;
};
